import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import QuickRecordStart from '~/components/test/createTest/QuickRecordStart';
import { api } from '~/trpc-extra/api';
import { useProjectId } from '../context/useProjectId';

// Convenience function that calls `api.test.run`
export const useCreateAndNavToTest = ({ name, userFlowId }: { name?: string; userFlowId?: string }) => {
  const router = useRouter();
  const projectId = useProjectId();

  const createTest = api.test.create.useMutation({
    onMutate: () => notifications.show({ message: 'Creating your test...', color: 'blue' }),
    onSuccess: (test) => router.push(`/project/${projectId}/test/${test.id}`).catch(() => undefined),
    onError: (e) => {
      console.error(e);
      notifications.show({
        message: 'Error Creating Test',
        color: 'red',
        title: e.message,
        icon: <IconExclamationCircle size="1rem" />,
      });
    },
  });

  const createTestHandler = useCallback(() => {
    if (!projectId) {
      notifications.show({
        message: 'Unable to Create Test',
        color: 'red',
        title: `A Project ID is required (check your URL)`,
        icon: <IconExclamationCircle size="1rem" />,
      });
      return;
    }

    modals.open({
      size: 'md',
      padding: '0',
      radius: 'md',
      centered: true,
      withCloseButton: false,
      children: (
        <QuickRecordStart
          testName={name}
          userFlowId={userFlowId}
        />
      ),
    });
  }, [createTest, projectId]);

  return createTestHandler;
};
